/* Clearspring drawer menu customisations */

(() => {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;

  const handleize = (str) =>
    String(str || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const getDrawerParts = () => {
  const drawer = document.querySelector('header-drawer.header__drawer');
  if (!drawer) return {};

  const details = drawer.querySelector(':scope > details');
  const toggle = details?.querySelector(':scope > summary.drawer__button');
  const panel = details?.querySelector(':scope > .drawer__content.js-drawer, :scope > .drawer__content');

  return { drawer, details, toggle, panel };
};

  document.addEventListener('click', (e) => {
    if (!isDesktop()) return;

    const item = e.target.closest('#header .header__nav-item[data-menu-item="Shop"]');
    if (!item) return;

    const link = item.querySelector(':scope > .header__nav-link');
    if (!link || !link.contains(e.target)) return;

    const sectionKey = handleize(item.getAttribute('data-menu-item'));

    if (sectionKey !== 'shop') return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    e.preventDefault();

    const { drawer, details, toggle, panel } = getDrawerParts();
    if (!drawer || !details || !toggle || !panel) return;

    const desktopNav = panel.querySelector('.drawer__nav--desktop');
    if (desktopNav) desktopNav.setAttribute('data-active-group', sectionKey);

    if (!details.hasAttribute('open')) {
      if (typeof drawer.toggleDrawer === 'function') drawer.toggleDrawer();
      else toggle.click();
    }

    panel.scrollTop = 0;
    panel.focus({ preventScroll: true });
  });

  (() => {
    let syncing = false;

    document.addEventListener(
      'toggle',
      (e) => {
        if (!isDesktop()) return;
        if (syncing) return;

        const current = e.target;
        if (!current.matches('.drawer__nav--desktop details.accordion__section')) return;
        if (!current.open) return;

        const nav = current.closest('.drawer__nav--desktop');
        if (!nav) return;

        syncing = true;

        nav.querySelectorAll('details.accordion__section[open]').forEach((details) => {
          if (details === current) return;

          const summary = details.querySelector(':scope > summary');
          if (summary) summary.click();
          else details.removeAttribute('open');
        });

        setTimeout(() => {
          syncing = false;
        }, 0);
      },
      true
    );
  })();

  document.addEventListener('click', (e) => {
    if (!isDesktop()) return;

    const { details, toggle } = getDrawerParts();
    if (!details || !toggle || !details.hasAttribute('open')) return;

    const drawerHost = details.closest('header-drawer');
    if (!drawerHost) return;

    const path = e.composedPath ? e.composedPath() : [];
    const clickedInsideDrawer =
      path.includes(drawerHost) ||
      (e.target instanceof Node && drawerHost.contains(e.target));

    if (clickedInsideDrawer) return;

    toggle.click();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    const { details, toggle } = getDrawerParts();
    if (!details || !toggle || !details.hasAttribute('open')) return;

    toggle.click();
  });
})();